
import { string } from 'yup';

const obj = {
    field: [
      {
        title: "Topic or Keyword",
        attr: "language",
        value: "",
        placeholder: "Topic or Keyword",
        label: "Which language are you using, will enable markup highlights",
        type: "text",
        maxLength: 40,
        yup: string().nullable().trim("Initially whitespace are not allowed").required("Topic or Keyword is Required"),
        id: "topic",
        // options: [{ title: "2nd Grader", value: "2nd Grader", desc: "Explain this like I'm 5 years old", Icon: AnnotationIcon },],
        // max: 100,
        min: 3,
        required: true,
        error: "",
        example: `JavaScript`,
      },
     
    ],
    example: [
      {
        title: "Topic or Keyword",
        attr: "language",
        value: "Cricket Batsman",
        placeholder: "Topic or Keyword",
        label: "Which language are you using, will enable markup highlights",
        type: "text",
        maxLength: 40,
        yup: string().nullable().trim("Initially whitespace are not allowed").required("Topic or Keyword is Required"),
        id: "topic",
        // options: [{ title: "2nd Grader", value: "2nd Grader", desc: "Explain this like I'm 5 years old", Icon: AnnotationIcon },],
        // max: 100,
        min: 3,
        required: true,
        error: "",
        example: `JavaScript`,
      },
      
    ],
    editor: {
      output: `1. Cricket Batting\n2. Cricket Strokes\n3. Run Scoring\n4. Batsman Records\n5. Cricket Legends\n6. Fielding Techniques\n7. Wicket Keeping\n8. Bowling Strategies\n9. Batting Averages\n10. Test Match Records`,
      
      
      
       
       
       
       
       
      
      
     
    
      
    },
  };
  
  export default obj;
  